import posthog, { isPostHogEnabled } from "@/posthog";

import type { AnalyticsProvider } from "./types";

export const posthogProvider: AnalyticsProvider = {
  startSession: (context) => {
    if (isPostHogEnabled) {
      posthog.capture("session_started", context);
    }
  },
  endSession: (context) => {
    if (isPostHogEnabled) {
      posthog.capture("session_ended", context);
    }
  },
  trackEvent: (name, props) => {
    if (isPostHogEnabled) {
      posthog.capture(name, props);
    }
  },
};
